var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"l-section l-section--main o-dashboard"},[_c('div',{staticClass:"l-container l-container--main o-dashboard__container"},[_c('dashboard-tabs'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }